import React, { useEffect, useState, useContext } from "react";
import { MyContext } from './MyContext';

const MonthlyComparisonChart = ({ apiUrl }) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const { lastUpdateTime } = useContext(MyContext);

    useEffect(() => {
        const fetchData = async () => {
            try {
                //console.log("fetchData")
                const response = await fetch(apiUrl);
                if (!response.ok) {
                    throw new Error("Failed to fetch data");
                }
                const jsonData = await response.json();
                setData(jsonData);
            } catch (error) {
                setError(error.message);
            }
        };

        fetchData();
    }, [apiUrl, lastUpdateTime]);

    if (error) return <p>Error: {error}</p>;
    if (!data) return <p>Loading...</p>;

    // Extract last two months
    const sortedMonths =
        data.sort(
            (a, b) =>{
                //console.log('a: ' + a + ' b: ' + b)
                //return new Date(a + "-01") - new Date(b + "-01")
                return new Date(a.month) - new Date(b.month)
        });

    if (sortedMonths.length < 2) {
        return <p>Not enough data to display comparison.</p>;
    }

    const previousMonth = sortedMonths[sortedMonths.length - 2];
    const currentMonth = sortedMonths[sortedMonths.length - 1];

    const previousTotal = previousMonth.total || 0;
    const currentTotal = currentMonth.total || 0;

    const comparisonRatio = previousTotal > 0 ? (currentTotal / previousTotal) * 100 : 100;
    const barWidth = Math.min(comparisonRatio, 100); // Max width 100%

    // Calculate expected progress
    const today = new Date();
    const currentYearMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;

    let expectedProgress = 100; // Default to 100% if comparing past months
    //console.log('Last data element in the array Year-Month: ' + currentMonth.month)
    //console.log('Todays  Year-Month: ' + currentYearMonth)
    if (currentMonth.month === currentYearMonth) {
        const daysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
        const currentDay = today.getDate();
        expectedProgress =  (currentDay / daysInMonth) * 100; // How far into the month we are
        // console.log('expectedProgress: ' + expectedProgress)
    }

    const markerPosition = Math.min(expectedProgress, 100); // Ensure within bar limits

    return (
        <div style={{ fontSize: '24px', fontFamily: 'Arial, sans-serif', marginLeft: '50px' }}>
            <h3 style={{ marginBottom:'0px'}}>Monthly Uptime Goal</h3>

            <div style={{ width: '92%', display: 'flex', alignItems: 'center', marginBottom:'0px' }}>
                <div style={{ width: '100%', position: 'relative', backgroundColor: '#cccccc', height: '40px', flexGrow: '1', borderRadius: '5px', overflow: 'hidden', border: '1px solid #aaa' }}>
                    {/* Current progress bar */}
                    <div style={{ backgroundColor: comparisonRatio >= 100 ? "#ffcc00" : "#76c7c0", height: '100%', width: `${barWidth}%` }}></div>
                    {/* Expected progress marker */}
                    <div style={{
                        position: "absolute",
                        left: `${markerPosition}%`,
                        top: "0",
                        height: "100%",
                        width: "0px",
                        borderLeft: "dashed #ff0000 6px", // Dashed red line,
                        // backgroundColor: "#ff0000", // Red marker for target
                    }}></div>
                </div>
                <span style={{ marginLeft: '10px', fontSize: '22px', color: '#000' }}>100% goal</span>
            </div>

            <p style={{ fontSize: '44px', color: '#555', marginTop: '0px', marginBottom: '10px' }}>
                Current month is {comparisonRatio.toFixed(0)}% of the previous month.
            </p>
            <div style={{ fontSize: '30px', marginBottom: '0px', marginTop: '0px'}}>
                <strong>Previous Month ({previousMonth.month}):</strong> {previousTotal.toFixed(0)} hours
            </div>
            <div style={{ fontSize: '30px', marginBottom: '-10px' }}>
                <strong>Current Month to date({currentMonth.month}):</strong> {currentTotal.toFixed(0)} hours
            </div>


            {/* If ahead of expected progress, show a thumbs-up */}
            {comparisonRatio >= expectedProgress && (
                <p style={{ fontSize: "35px", color: "#28a745" }}>
                    👍 On track! You're ahead of schedule.
                </p>
            )}

            {/* If behind expected progress, show a warning */}
            {comparisonRatio < expectedProgress && (
                <p style={{ fontSize: "35px", color: "#dc3545" }}>
                    ⚠️ Behind pace! Expected: {expectedProgress.toFixed(0)}%
                </p>
            )}

            {comparisonRatio >= 100 && (
                <p style={{ fontSize: "44px", color: "#ff6600" }}>
                    🎉Congratulations! Your productivity is at {comparisonRatio.toFixed(0)}%! 🎉
                </p>
            )}
        </div>
    );
};

export default MonthlyComparisonChart;
